import "firebase/analytics";
import { getAnalytics, setAnalyticsCollectionEnabled } from "firebase/analytics";
import { initializeApp } from "firebase/app";
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from "firebase/app-check";
import { getAuth } from "firebase/auth";
import "firebase/database";
import { getDatabase } from "firebase/database";
import "firebase/performance";
import { getPerformance } from "firebase/performance";
import "firebase/remote-config";
import { isCloudEnv } from "./env.ts";

const config = {
	apiKey: "AIzaSyAaFpGrDQWREIYlqPG06gn4gg5oB0E58M8",
	authDomain: "auth.bria.ai",
	databaseURL: "https://image-viewer-120cb.firebaseio.com",
	projectId: "image-viewer-120cb",
	storageBucket: "image-viewer-120cb.appspot.com",
	messagingSenderId: "573857372557",
	appId: "1:573857372557:web:3f8218f4d1ef37903a85c4",
	measurementId: "G-S63HD9ZS4V",
};

export const firebaseApp = initializeApp(config);
startAppCheck();
export const firebaseDatabase = getDatabase(firebaseApp);
export const firebaseAuth = getAuth(firebaseApp);
export const firebasePerformance = getPerformance(firebaseApp);
export const firebaseAnalytics = getAnalytics(firebaseApp);
const enableAnalytics = isCloudEnv();
firebasePerformance.dataCollectionEnabled = enableAnalytics;
firebasePerformance.instrumentationEnabled = enableAnalytics;
setAnalyticsCollectionEnabled(firebaseAnalytics, false);

/**
 * Starts Firebase App Check when VITE_FIREBASE_APPCHECK_SITE_KEY (a reCAPTCHA Enterprise site key) is
 * set; otherwise does nothing. Auth and RTDB requests then carry an App Check token, but nothing is
 * rejected until enforcement is turned on in the Firebase console. Runs before any Auth request.
 * Local dev: set VITE_FIREBASE_APPCHECK_DEBUG_TOKEN to a debug token registered in the console.
 */
function startAppCheck(): void {
	const siteKey = import.meta.env.VITE_FIREBASE_APPCHECK_SITE_KEY as string | undefined;
	if (typeof window === "undefined" || !siteKey) return;
	const debugToken = import.meta.env.VITE_FIREBASE_APPCHECK_DEBUG_TOKEN as string | undefined;
	if (debugToken) {
		(self as { FIREBASE_APPCHECK_DEBUG_TOKEN?: string }).FIREBASE_APPCHECK_DEBUG_TOKEN = debugToken;
	}
	try {
		initializeAppCheck(firebaseApp, {
			provider: new ReCaptchaEnterpriseProvider(siteKey),
			isTokenAutoRefreshEnabled: true,
		});
	} catch (error) {
		// Never let App Check break sign-in: without it requests simply go out unverified.
		console.warn("[AppCheck] Failed to start App Check", error);
	}
}
